var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-customer" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          attrs: {
            model: _vm.searchValue,
            size: "small",
            inline: "",
            "label-position": "top",
          },
        },
        [
          _vm.isWeekly
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("sfe.performanceReport.select.week") },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.searchValue.value,
                      options: _vm.weekSelectOptions,
                      clearable: false,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.searchValue, "value", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          ["Sales leader", "DA", "FDM"].includes(_vm.userRole)
            ? _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("sfe.performanceReport.select.rsm") },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      multiple: "",
                      "collapse-tags": "",
                      labelKey: "empName",
                      valueKey: "empNo",
                      val: _vm.searchValue.rsmList,
                      options: _vm.rsmList,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.searchValue, "rsmList", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { staticClass: "export-button", attrs: { label: " " } },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: {
                        pageName: "performanceReport",
                        list: ["EXPORT"],
                      },
                      expression:
                        "{ pageName: 'performanceReport', list: ['EXPORT'] }",
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportHandler },
                },
                [_vm._v(_vm._s(_vm.$t("common.export")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "highlight-current-row": "",
            "tooltip-effect": "dark",
            "default-sort": _vm.defaultSort,
          },
          on: { "sort-change": _vm.sortTable },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "srEmpNo",
              label: _vm.$t("sfe.performanceReport.table.srEmpNo"),
              align: "left",
              "show-overflow-tooltip": "",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "srEmpName",
              label: _vm.$t("sfe.performanceReport.table.srEmpName"),
              align: "left",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: _vm.userRole !== "SR" ? "pointer" : "",
                        on: {
                          click: function ($event) {
                            return _vm.detail(scope.row.srEmpNo)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.srEmpName) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "planQty",
              label: _vm.$t("sfe.performanceReport.table.planQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitPlanQty",
              label: _vm.$t("sfe.performanceReport.table.visitPlanQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "taskQty",
              label: _vm.$t("sfe.performanceReport.table.taskQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "visitTaskQty",
              label: _vm.$t("sfe.performanceReport.table.visitTaskQty"),
              align: "left",
              "show-overflow-tooltip": "",
              sortable: "custom",
            },
          }),
          _vm._v(" "),
          _vm.userRole !== "SR"
            ? _c("el-table-column", {
                attrs: {
                  label: _vm.$t("sfe.performanceReport.table.action"),
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-button", {
                            staticClass: "t-square-btn",
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-chat-dot-square",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.comment(
                                  scope.row,
                                  "srEmpNo",
                                  "srEmpNo",
                                  "visitPlan"
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("el-button", {
                            staticClass: "t-square-btn",
                            attrs: {
                              type: "danger",
                              size: "mini",
                              icon: "el-icon-notebook-2",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.assignTasks(scope.row, "visitPlan")
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  859434061
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
        on: {
          "update:page": function ($event) {
            _vm.currPage = $event
          },
          "update:limit": function ($event) {
            _vm.limit = $event
          },
          pagination: _vm.fetchData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }